"use client";

import Picture1 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal1.webp";
import Picture2 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal2.webp";
import Picture3 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal3.webp";
import Picture4 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal4.webp";
import Picture5 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal5.webp";
import Picture6 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal6.webp";
import Picture7 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal7.webp";
import Picture8 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal8.webp";
import Picture9 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal9.webp";
import Picture10 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal10.webp";
import Picture11 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal11.webp";
import Picture12 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal12.webp";
import Picture13 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal13.webp";
import Picture14 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal14.webp";
import Picture15 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal15.webp";
import Picture16 from "@/app/azerbaijan/main-page/images/handpicked-2/horizontal16.png";

import Airplane from "@/public/svg/destinations/hand-picked/visa.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import Activity from "@/public/svg/destinations/hand-picked/activity.svg";
import Food from "@/public/svg/destinations/hand-picked/all-board.svg";
import Car from "@/public/svg/destinations/hand-picked/car.svg";
import Dot from "@/public/svg/destinations/hand-picked/dot.svg";
import Iconpicture from "@/public/png/common/group-tour/all-premium-inclusive.svg";


import HorizontalTicketCard1 from "@/components/azerbaijan-horizontal-ticket-group-card/ticket-card";

import Title from "@/components/title/Title";

import "@/styles/common/swiper.scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss";
import "./horizontal-card.scss";
import "@/sections/common/horizontal-card/horizontal-card.scss";
import { getImageUrl } from "@/utils/imageUrl";
import { get } from "http";


const Honeymoon = [

    {
        name: "7 Nights Luxury Escape to Azerbaijan",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal1.webp"),
        iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala | 1N Sheki",
        place: "5N Baku | 1N Gabala | 1N Sheki",
        price: "INR 68,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Explore the vibrant streets of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: " Discover the beauty of Sheki Khan’s Palace",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit the surreal Gobustan Mud Volcanoes",
            },
             
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
        list: [
             {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "3 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
            
        ],
        trends: [
            {
                title: "8 days",
                color: "#D0CECE",
            },
        ],
        
    },
    {
        name: "Azerbaijan Baku & Mountains Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal2.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala | 1N Sheki",
        place: "2 Places",
        price: "INR 74,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Panoramic city tour of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Unwind at the serene Nohur Lake",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Enjoy breathtaking views at Gabala Tufandag Resort",
            },
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "4 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "8 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Exclusive 7 Nights Azerbaijan Baku Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal3.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala | 1N Sheki",
        place: "8 Places",
        price: "INR 92,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Marvel at the futuristic architecture of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Experience winter sports at Shahdag Resort",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit the historic Juma Mosque in Sheki",
            },
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "5 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            
            {
                title: "8 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Trending",
                color: "#25d366",
            },
        ],
    },
    {
        name: "6 Nights Azerbaijan Adventure Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal4.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala",
        place: "8 Places",
        price: "INR 61,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Walk through the charming Old City of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Experience the thrill of Gabala’s cable car ride",
            },
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "3 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "7 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Widely Loved",
                color: "#25d366",
            },
        ],
    },
        {
        name: "6 Nights Baku & Gabala Scenic Retreat",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal5.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala",
        place: "8 Places",
        price: "INR 67,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "See the iconic Flame Towers of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: " Relax at the picturesque Yeddi Gozel Waterfall",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "4 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "7 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
    {
        name: "6 Nights Ultimate Azerbaijan Getaway ",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal6.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku | 1N Gabala",
        place: "8 Places",
        price: "INR 82,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [

            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Indulge in Baku’s vibrant nightlife",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit the UNESCO-listed Gobustan Rock Art",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "5 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "7 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "5 Nights Classic Azerbaijan Tour ",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal7.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 53,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Discover Baku's historical wonders",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Witness the beauty of Gobustan Mud Volcanoes",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Experience the adventure at Shahdag",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "3 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Most Loved",
                color: "#25d366",
            },
        ],
    },
     {
        name: "5 Nights Azerbaijan City & Nature Escape ",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal8.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 59,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "  Explore the vibrant streets of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Relax at Gabala’s picturesque lakes",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit the scenic Shahdag Mountain",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "4 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
     {
        name: "5 Nights Luxury Azerbaijan Retreat",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal9.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 71,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Marvel at the architectural beauty of Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Enjoy breathtaking mountain views in Gabala",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: " Experience premium leisure at Shahdag",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "5 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
     {
        name: "5 Nights Baku Highlights Tour ",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal10.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 50,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
             
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit iconic landmarks in Baku",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Experience the fascinating Gobustan Rock Art",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Enjoy the high-altitude views of Shahdag",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "3 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Most Popular",
                color: "#25d366",
            },
        ],
    },
         {
        name: "5 Nights Azerbaijan Cultural & Adventure Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal11.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 56,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Explore Baku’s cultural heritage",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Adventure through the unique Gobustan landscapes",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Relax in the Shahdag mountain resort",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "4 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Widely Loved",
                color: "#25d366",
            },
        ],
    },
      {
        name: "5 Nights Azerbaijan Luxury Explorer",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal12.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "5N Baku",
        place: "8 Places",
        price: "INR 68,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [

            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Immerse yourself in Baku’s nightlife",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Experience Gabala’s lush greenery",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Discover adventure in Shahdag",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "5 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "6 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
     {
        name: "4 Nights Best of Azerbaijan Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal13.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "4N Baku",
        place: "8 Places",
        price: "INR 45,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Explore Baku’s Old City charm",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Discover the historic Sheki Khan’s Palace",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Marvel at the unique Gobustan petroglyphs",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "3 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "5 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Top-Rated",
                color: "#25d366",
            },
        ],
    },
       {
        name: "Azerbaijan Express Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal14.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "4N Baku",
        place: "8 Places",
        price: "INR 49,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: " See Baku’s stunning modern skyline",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title:  "Enjoy a day trip to Gabala",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Visit the famous Yeddi Gozel Waterfall",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "4 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "5 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Widely Loved",
                color: "#25d366",
            },
        ],
    },
        {
        name: "Azerbaijan Express Tour",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/handpicked-2/horizontal15.webp"),
    iconpicture:getImageUrl("/png/common/group-tour/all-premium-inclusive.svg"),
        location: "4N Baku",
        place: "8 Places",
        price: "INR 59,999",
        cutoffprice: "₹95,000",
        offpercent: "10%",
        type: "visa",
        link :"#hero",
        listvertical: [

            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: " Experience Baku’s blend of history and modernity",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title:  "Visit the surreal Gobustan Mud Volcanoes",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/dot.svg"),
                title: "Enjoy breathtaking mountain landscapes",
            },
            
        ],
        list: [
            {
                icon: getImageUrl("/svg/destinations/hand-picked/building.svg"),
                title: "5 Star Hotels",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/activity.svg"),
                title: "Sightseeings",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/all-board.svg"),
                title: "Breakfast",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/visa.svg"),
                title: "Visa",
            },
            {
                icon: getImageUrl("/svg/destinations/hand-picked/car.svg"),
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "5 Days ",
                color: "#D0CECE",
            },
        ],
        mostbook: [
            {
                title: "Most Booked",
                color: "#25d366",
            },
        ],
    },
];



const AzerbaijanHorizontalCard = () => {
    return (
        <section className="horizontal-card-section py-10 md:py-20" id="tours">
            <div className="horizontal-card-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Best Azerbaijan Tour Packages From India" />
                <div className="horizontal-card-wrapper flex flex-col gap-14">
                    {Honeymoon.map((h, index) => {
                        return <HorizontalTicketCard1  key={index} {...h} />;
                    })}
                </div>
            </div>
        </section>
    );
};











export default AzerbaijanHorizontalCard;
